import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Button } from '../button/button';

@Component({
  selector: 'app-delete-batch-modal',
  standalone: true,
  imports: [CommonModule, Button],
  templateUrl: './delete-batch-modal.html',
  styleUrl: './delete-batch-modal.css'
})
export class DeleteBatchModal {
  @Input() title: string = 'Delete Batch';
  @Input() message: string = 'Do you want to delete this batch?';
  @Input() confirmLabel: string = 'Delete';
  @Input() busyLabel: string = 'Deleting...';
  @Input() isDeleting: boolean = false;
  @Output() cancel = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<void>();

  onCancel() {
    if (this.isDeleting) return;
    this.cancel.emit();
  }

  onConfirm() {
    if (this.isDeleting) return;
    this.confirm.emit();
  }
}
